
const initialState = {};

export function updateJourneyVehicle(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_JOURNEY_VEHICLE.SUCCESS':
      return {
        ...state,
        intervention: action.intervention.body
      };
    default:
      return state
  }
}
